import moment from "moment";

//get cookie from name
export function getCookie(cname){
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function compareEditDateTimeDesc(a, b){
  return moment(b.editDateTime).unix() - moment(a.editDateTime).unix();
}

export function compareDiaryDateAsc(a, b){
  return moment(a.diaryDate).unix() - moment(b.diaryDate).unix();
}

export function compareDiaryDateDesc(a, b){
  return moment(b.diaryDate).unix() - moment(a.diaryDate).unix() || b.diaryPeriod!=a.diaryPeriod ||  moment(b.editDateTime).unix() - moment(a.editDateTime).unix();
}

export function maxOrderIdPlusPlus(records){
  let maxValue = -1;
  for (let i in records) {
    let item = records[i];
    if (item && (maxValue < item.order)) {
      maxValue = item.order;
    }
  }
  return ++maxValue;
}

export function autoIncerateOrder(oldMaxOrderId, records){
  let maxValue = maxOrderIdPlusPlus(records);
  return (oldMaxOrderId >= maxValue) ?  ++oldMaxOrderId : maxValue
}

export function finOrderIndex(records, orderId){
  for (let i in records) {
    let item = records[i];
    if (item.order == orderId) {
      return i;
    }
  }
  // return default index is -1
  return -1;
}

export function findDiaryIdLatest(records){
  const arr = records;
  const revisionId = Math.max.apply(Math, arr.map(function (o) { return o.revision; }));

  // 同じ revision を持つ diary を全て取得
  const diariesWithMaxRevision = arr.filter(item => item.revision == revisionId);

  if (diariesWithMaxRevision.length === 0) {
    return -1;
  }

  // 同じ revision が複数ある場合は editDateTime で降順ソートして最新を取得
  if (diariesWithMaxRevision.length > 1) {
    diariesWithMaxRevision.sort(compareEditDateTimeDesc);
  }

  return diariesWithMaxRevision[0].diaryId;
}

export function isRevisionLastestStateCo2Complete(diaryRevision, diaryDate, diaryPeriod=undefined){
  let diaryState = "";
  let revisionLatest = 0;
  for (const diary of diaryRevision) {
    if (revisionLatest < parseInt(diary.revision) && diary.diaryDate == diaryDate && diary.diaryPeriod == diaryPeriod) {
      revisionLatest = parseInt(diary.revision);
      diaryState = diary.state;
    }
  }
  if (diaryState == "inputCo2Values") {
    return true;
  }
  return false;
}

export function validateYear(value){
  let numbers = /^[0-9]+$/;
  if (!value.match(numbers) || value.length != 4) {
    return false;
  }
  return true;
}

export function validateMonth(value){
  let numbers = /^[0-9]+$/;
  if (!value.match(numbers) || (value.length != 2 && value.length != 1)) {
    return false;
  }
  return true;
}

export function validateValue(value){
  let numbers = /^\d+(\.\d+)?$/;
  if (!value.match(numbers)) {
    return false;
  }
  return true;
}

export function validateJPY(value){
  let numbers = /^\d+$/;
  if (!value.match(numbers)) {
    return false;
  }
  return true;
}

export function configDatePick(format, isInline = false){
  return {
    format: format,
    useCurrent: false,
    showClear: true,
    showClose: true,
    locale: "ja",
    icons: {
      time: "far fa-clock",
      date: "far fa-calendar",
      up: "fas fa-arrow-up",
      down: "fas fa-arrow-down",
      previous: "fas fa-chevron-left",
      next: "fas fa-chevron-right",
      today: "fas fa-calendar-check",
      clear: "far fa-trash-alt",
      close: "far fa-times-circle",
    },
    inline: isInline
  };
}

export function isInt($event){
  if($event.key.match(/[a-zA-Z^.]/g) && $event.keyCode!=8){
    $event.preventDefault();
  }
}

export function isFloat($event){
  if($event.key.match(/[a-zA-Z]/g) && $event.keyCode!=8){
    $event.preventDefault();
  }
}

export function validateMetaData(data) {
  return !!data?.siteName && !!data?.siteId
}

// UUID v4 生成関数（作業記録のoriginal_row_id用）
export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// originalRowIdで作業記録のインデックスを検索（順序変更時の差分比較改善用）
// originalRowIdがない既存データの場合はorderベースのフォールバック検索を行う
export function findIndexByOriginalRowId(records, originalRowId, fallbackOrder = null) {
  // originalRowIdベースの検索を試行
  if (originalRowId) {
    for (let i in records) {
      let item = records[i];
      if (item.record?.originalRowId == originalRowId) {
        return i;
      }
    }
  }
  
  // originalRowIdが見つからない場合、orderベースのフォールバック検索
  if (fallbackOrder !== null) {
    return finOrderIndex(records, fallbackOrder);
  }
  
  return -1;
}

export default {
  compareEditDateTimeDesc,
  compareDiaryDateAsc, compareDiaryDateDesc,
  maxOrderIdPlusPlus, autoIncerateOrder, finOrderIndex, findDiaryIdLatest, isRevisionLastestStateCo2Complete,
  validateYear, validateMonth, validateValue, configDatePick, isInt, isFloat, validateMetaData, generateUUID, findIndexByOriginalRowId
};
